
    import {computed, ComputedRef, defineComponent, reactive, watch, onMounted, nextTick, onUnmounted} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";

    interface State {
        vin: string;
        carModel: string;
        carImg: string;
        isNoDefect: ComputedRef<boolean>; // 是否为无火烧无泡水无重大事故的车
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        isShowModel: boolean; // 是否打开弹框
        isDisplay: boolean; // 是否显示吸顶块
        offsetTop: number; // 滚动距离
        opacityStyle: number; // 透明度
        channelType: string; // 家选 承诺100天 
        specialNum: number; // 专项检测数量
        reportLevel: number; // 报告标准
        protectTime: string; // 承诺天数，家选100，其他90
        commitmentTitle: string;
        detectionLabel: string[];
        statementCommitment: string;
    }

    export default defineComponent({
        name: "reportMain",
        setup() {
            const {query} = useRoute();
            let state: State = reactive({
                vin: '',
                carModel: '',
                isNoDefect: false as any,
                point: "N" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                isShowModel: false,
                isDisplay: false as any,
                opacityStyle: 1,
                offsetTop: 0,
                carImg: '',
                channelType: `${query.channelType}` || '',
                specialNum: 0,
                reportLevel: 0,
                protectTime: '',
                commitmentTitle: '',
                detectionLabel: [],
                statementCommitment: '',
            })
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path.replace(reg, "https://$2$3$4$5$6");
                return path
            }
            function Trim(str){ 
                return str.replace(/(^\s*)|(\s*$)/g, ""); 
            }
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {basicItemInfos, configureInfos, accident, isAccident, fire, isFire, soakWater, isWater, vin, modelName, photoList,
                appearance, interior, lighting, startUp, power, machine, bottom, reportConfigInfo} = data;
                state.isNoDefect = computed(() => {
                    return isAccident === 0 && isFire === 0 && isWater === 0;
                })
                state.point = computed(() => {
                    return state.isNoDefect ? 'N' : 'Y';
                })
                state.isAccident = isAccident;
                state.isFire = isFire;
                state.isWater = isWater;
                state.vin = vin;
                state.carModel = modelName;
                let carImgObj = photoList.filter(function(item: any){
                    return item.photoCode == "SP1"; 
                })
                state.carImg = urlConversion(carImgObj[0].smallPhotoUrl);
                state.channelType = `${query.channelType}` || '';
                state.protectTime = state.channelType === 'jiaxuan' ? '100' : '90';
                state.reportLevel = Number(`${query.reportLevel}`) || 0;
                state.commitmentTitle = reportConfigInfo ? reportConfigInfo.commitmentTitle : '';
                let localArray = reportConfigInfo ? reportConfigInfo.detectionLabel : [];
                if (localArray.length > 0) {
                    for (let i = 0; i < localArray.length; i++) {
                        if (
                        Trim(localArray[i]) == "" ||
                        localArray[i] == null ||
                        typeof localArray[i] == undefined
                        ) {
                            localArray.splice(i, 1);
                            i = i - 1;
                        }
                    }
                }
                state.detectionLabel = localArray;
                state.statementCommitment = reportConfigInfo ? reportConfigInfo.statementCommitment : [];
                if(state.reportLevel === 8 || state.reportLevel === 0 || state.reportLevel === 32) {
                    state.specialNum = configureInfos.length + 
                                   basicItemInfos.length + 
                                   accident.itemCount + 
                                   fire.itemCount + 
                                   soakWater.itemCount
                }
                if(state.reportLevel === 1){
                    state.specialNum = configureInfos.length +  // 
                                   basicItemInfos.length + 
                                   accident.itemCount + 
                                   fire.itemCount + 
                                   soakWater.itemCount +
                                   (appearance && appearance !== null ?  appearance.itemCount : 0) +
                                   (interior && interior !== null ? interior.itemCount : 0) +
                                   (lighting && lighting !== null ? lighting.itemCount : 0) +
                                   (startUp && startUp !== null ? startUp.itemCount : 0)
                }
                if(state.reportLevel === 2 || state.reportLevel === 16) {
                    state.specialNum = configureInfos.length + // 配置信息
                                   basicItemInfos.length +  // 基本信息
                                   accident.itemCount +  // 事故
                                   fire.itemCount +  // 火烧
                                   soakWater.itemCount + // 泡水
                                   (appearance && appearance !== null ?  appearance.itemCount : 0) + // 外观
                                   (interior && interior !== null ? interior.itemCount : 0) + // 内饰
                                   (lighting && lighting !== null ? lighting.itemCount : 0) + // 灯光
                                   (startUp && startUp !== null ? startUp.itemCount : 0) + // 启动
                                   (power && power !== null ? power.itemCount : 0) + // 动力
                                   (machine && machine !== null ? machine.itemCount : 0) + // 机舱
                                   (bottom && bottom !== null ? bottom.itemCount : 0) // 底盘
                }
                if(state.reportLevel === 4) {
                    state.specialNum = configureInfos.length + 
                                   basicItemInfos.length + 
                                   accident.itemCount + 
                                   fire.itemCount + 
                                   soakWater.itemCount +
                                   (startUp && startUp !== null ? startUp.itemCount : 0) +
                                   (power && power !== null ? power.itemCount : 0) +
                                   (machine && machine !== null ? machine.itemCount : 0) +
                                   (bottom && bottom !== null ? bottom.itemCount : 0)
                }
            })
            function initHeight(){ // 监听滚动方法
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                state.isDisplay = scrollTop > (state.offsetTop) ? true : false;
                let opacity = scrollTop / (state.offsetTop);
                opacity = opacity > 1 ? 1 : opacity;// 渐变色从0到1
                state.opacityStyle = opacity;
                // 保存监听到的数据于vuex
                store.dispatch('saveIsDisplay', {isDisplay: state.isDisplay})
                store.dispatch('saveOpacityStyle', {opacityStyle: state.opacityStyle})
                // 获取headTip组件DOM元素
                let headTip: any = document.getElementById("headMainTop");
                headTip.style.top = (scrollTop / 1.5) + 'px'
            }
            onMounted(() => {
                // 监听dom渲染完成
                nextTick(function(){
                    // 这里boxFixedReportMain是吸顶元素的ID
                    let header: any = document.getElementById("boxFixedReportMain");
                    // 这里要得到top的距离和元素自身的高度
                    state.offsetTop = header.offsetTop;
                    window.addEventListener('scroll', initHeight);
                });
            })
            onUnmounted(()=> {
                window.removeEventListener('scroll', initHeight, false)
            })
            return {
                state,
                initHeight,
                Trim
            }
        },
        methods: {
            hiddenModel(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            },
            showModel(){
                this.state.isShowModel = true
                document.body.style.overflow = "hidden" 
            }
        }
    })
